import IndeterminateCheckBoxTwoToneIcon from '@mui/icons-material/IndeterminateCheckBoxTwoTone';
import React from 'react';

import { FormOperationsEnum } from 'common/enum/Form.enum';
import { useView } from 'common/hooks';
import BaseDataExplorerListItem from 'features/data-explorer/components/base-data-explorer-list-Item.component';
import {
  ExplorerDataMapItem,
  HierarchicalDataMapping,
} from 'features/data-explorer/types/explorer-data.type';
import { HierarchicalExplorerListItemProps } from 'features/data-explorer/types/hierarchical-explorer-list-item-props.type';
import {
  convertExplorerDataToFilter,
  hasSelectedChild,
  isSelectedFilter,
} from 'features/static-data';
import { FilterCheckbox } from '../styles/filter-checkbox.component';
import { StyledChip } from 'common/components/cx-chip/cx-chip.styles';
import { Typography } from 'common/components/material';
import * as _ from 'lodash';

const FilterListItem: React.FC<HierarchicalExplorerListItemProps> = ({
  data,
  active,
  activeFilterMap = {},
  mapping,
  showArrow,
  labelKey = 'name',
  onItemAction,
  dataType,
  arrowDirection,
  size,
}) => {
  const { isDesktopView } = useView();
  const mapItem = mapping ? mapping[data.id] : data;
  const filter = convertExplorerDataToFilter(data);
  const IconComponent = data?.IconComponent;

  const excludedTypes = [
    'COMPONENT',
    'VENUE_TYPE',
    'WORKFLOW_TYPE',
    'ASSET_CLASS',
    'PROTOCOL',
    'MARKET',
  ];

  function updateData(data: ExplorerDataMapItem): ExplorerDataMapItem {
    if (
      data.type === 'MATCHING_ENGINE_SKILL' &&
      data.subType &&
      !excludedTypes.includes(data.subType)
    ) {
      return {
        ...data,
        subType: 'SKILL',
      };
    }

    return data;
  }

  const updatedData = updateData(data);
  const selected = isSelectedFilter(filter, activeFilterMap, dataType, mapping);
  const selectedChild =
    !updatedData.excludeChildren &&
    hasSelectedChild(mapItem, activeFilterMap, mapping as HierarchicalDataMapping, dataType);

  const toggleCheckbox = () => {
    onItemAction({
      data: filter,
      actionType: 'toggleFilter',
      mapping,
      value: !selected,
    });
  };

  return (
    <>
      <BaseDataExplorerListItem
        label={updatedData[labelKey as keyof typeof updatedData] as string}
        selected={isDesktopView && active}
        showArrow={showArrow}
        arrowDirection={arrowDirection}
        size={size}
        data-testid="filter-list-item"
        onClick={(e: React.MouseEvent<HTMLElement>) => {
          e.stopPropagation();
          // Clicking on the text toggles the checkbox instead of expanding the children
          if (
            e.target instanceof HTMLElement &&
            e.target.className.includes('MuiTypography-root')
          ) {
            toggleCheckbox();
          } else {
            showArrow &&
              onItemAction({
                data: updatedData,
                actionType: FormOperationsEnum.EXPAND,
                event: e,
              });
          }
        }}
        showBorder={!isDesktopView}
        startAdornment={
          <>
            <FilterCheckbox
              checked={!!selected}
              indeterminate={selectedChild && !selected}
              indeterminateIcon={<IndeterminateCheckBoxTwoToneIcon />}
              onClick={(e: React.MouseEvent) => {
                e.stopPropagation();
                toggleCheckbox();
              }}
              size={size}
            />
            {IconComponent}
          </>
        }
        sx={{ cursor: showArrow ? 'pointer' : 'default' }}
      />
    </>
  );
};

export default FilterListItem;
